import type { CSSProperties, ReactNode } from 'react'
import Markdown, { type Components } from 'react-markdown'

const externalLink: Components['a'] = ({ children, href }) => (
  <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
)

// Markdown images are deliberately omitted. Agent-authored client copy needs
// headings/lists/emphasis/links, but a remote image would also be an invisible
// tracking request made from the recipient's browser.
const blockComponents: Components = { a: externalLink, img: () => null }

// Inline mode is available for compact labels. Block mode is used for briefs,
// notes, and question prompts so headings, paragraphs, and lists stay readable.
const inlineElements = ['a', 'strong', 'em', 'code', 'br']

export function MarkdownText({ children, inline = false, className = '', style }: {
  children: string | null | undefined
  inline?: boolean
  className?: string
  style?: CSSProperties
}) {
  if (!children) return null
  const classes = ['markdown-text', inline ? 'markdown-text--inline' : '', className].filter(Boolean).join(' ')
  const content: ReactNode = (
    <Markdown skipHtml components={blockComponents}
      allowedElements={inline ? inlineElements : undefined} unwrapDisallowed={inline}>{children}</Markdown>
  )
  return inline
    ? <span className={classes} style={style}>{content}</span>
    : <div className={classes} style={style}>{content}</div>
}
